import { useState } from 'react';

const useForm = (options) => {
    const [data, setData] = useState(((options === null || options === void 0 ? void 0 : options.initialValues) || {}));
    const [errors, setErrors] = useState({});
    const validate = (value, validation) => {
        var _a, _b;
        if (((_a = validation === null || validation === void 0 ? void 0 : validation.required) === null || _a === void 0 ? void 0 : _a.value) && !value) {
            return (_b = validation === null || validation === void 0 ? void 0 : validation.required) === null || _b === void 0 ? void 0 : _b.message;
        }
        const pattern = validation === null || validation === void 0 ? void 0 : validation.pattern;
        if ((pattern === null || pattern === void 0 ? void 0 : pattern.value) && !(pattern === null || pattern === void 0 ? void 0 : pattern.value.test(value))) {
            return pattern.message;
        }
        const custom = validation === null || validation === void 0 ? void 0 : validation.custom;
        if ((custom === null || custom === void 0 ? void 0 : custom.isValid) && !custom.isValid(value)) {
            return custom.message;
        }
        return null;
    };
    const handleChange = (key, primitiveValue, sanitizeFn) => {
        var _a;
        const value = sanitizeFn ? sanitizeFn(primitiveValue) : primitiveValue;
        const validation = (_a = options === null || options === void 0 ? void 0 : options.validations) === null || _a === void 0 ? void 0 : _a[key];
        const err = validate(value, validation);
        const newErrors = Object.assign({}, errors);
        if (err) {
            newErrors[key] = err;
        }
        else {
            delete newErrors[key];
        }
        setErrors(newErrors);
        setData((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: value })));
    };
    const clearErrors = (key) => {
        if (!key)
            setErrors({});
        else {
            setErrors((curr) => {
                const newErr = Object.assign({}, curr);
                delete newErr[key];
                return newErr;
            });
        }
    };
    const handleSubmit = async () => {
        var _a;
        const validations = options === null || options === void 0 ? void 0 : options.validations;
        if (validations) {
            let valid = true;
            const newErrors = {};
            for (const key in validations) {
                const value = data[key];
                const validation = validations[key];
                const err = validate(value, validation);
                if (err) {
                    valid = false;
                    newErrors[key] = err;
                }
            }
            if (!valid) {
                setErrors(newErrors);
                return;
            }
        }
        setErrors({});
        await ((_a = options.onSubmit) === null || _a === void 0 ? void 0 : _a.call(options, data));
    };
    return {
        data,
        handleChange,
        handleSubmit,
        errors,
        clearErrors,
    };
};

export { useForm as u };
